<template>
  <vx-tooltip :text="styleName" position="left">
    <img
      id="change-map-style-img"
      :src="styleImg"
      @click.stop="onChangeMapStyle()"
      class="style-icon cursor-pointer"
    />
  </vx-tooltip>
</template>

<script>
import LocalDbService from "@/services/localDbService";
import FireStoreService from "@/services/fireStoreService";
import { createNamespacedHelpers } from "vuex";

// Store
const {
  mapActions: mapActionsOfVesselView,
} = createNamespacedHelpers("enterpriseVesselView");

// Mixins
import {LayerMixin} from "@/mixins";

export default {
  mixins: [LayerMixin],
  props: {
    map: Object,
    mapbox: Object,
  },
  data() {
    return {
      imageDefault: require("@/assets/images/pages/map/streetmap.png"),
      imageSatellite: require("@/assets/images/pages/map/sattellite.png"),
      mapStyle: this.MAP_DEFAULT_STYLE_URL
    };
  },
  watch: {},
  async mounted() {
    this.mapStyle = await LocalDbService.getMapStyle();
  },
  computed: {
    styleName() {
      return this.mapStyle === this.MAP_DEFAULT_STYLE_URL ? "航空地図" : "標準地図";
    },
    styleImg() {
      return this.mapStyle === this.MAP_DEFAULT_STYLE_URL
        ? this.imageSatellite
        : this.imageDefault;
    }
  },
  methods: {
    ...mapActionsOfVesselView(["setMapStyle"]),

    onChangeMapStyle() {
      if (this.mapStyle === this.MAP_DEFAULT_STYLE_URL) {
        this.setMapStyle(this.MAP_SATELLITE_STYLE_URL)
        this.mapStyle = this.MAP_SATELLITE_STYLE_URL;
        FireStoreService.saveMapStyle(this.MAP_SATELLITE_STYLE_URL);
        LocalDbService.saveMapStyle(this.MAP_SATELLITE_STYLE_URL);
      } else {
        this.setMapStyle(this.MAP_DEFAULT_STYLE_URL)
        this.mapStyle = this.MAP_DEFAULT_STYLE_URL;
        FireStoreService.saveMapStyle(this.MAP_DEFAULT_STYLE_URL);
        LocalDbService.saveMapStyle(this.MAP_DEFAULT_STYLE_URL);
      }
    }
  }
};
</script>

<style lang="scss">
  #change-map-style-img{
    width: 52px;
    height: 52px;
    border-radius: 5px;
  }
</style>
